import axios from 'axios';

const updateMetadata = ({ importId, sectionId, meta }) =>
  axios.put(`imports/${importId}/sections/${sectionId}/metadata`, {
    metadata: meta
  });

export { updateMetadata };
